<div class="dropdown" [appDropdownHover]="!!options?.length">
    <ng-content></ng-content>

    <div class="dropdown__menu" data-dropdown>
        <div class="dropdown__menu__wrapper">
            <button
                *ngFor="let item of options"
                (click)="item.onClick()"
                class="item"
            >
                <div *ngIf="item.img" [innerHTML]="item.img" class="icon"></div>
                <span>
                    {{item.title | translate}}
                </span>
            </button>
        </div>
    </div>
</div>
